import Vue from 'vue';
import VueRouter from 'vue-router';
import store from './store';

import Login from '@/csmworkflow/js/views/Login';
import Report from '@/csmworkflow/js/views/Report';
import MyWeek from '@/csmworkflow/js/views/MyWeek';
import Project from '@/csmworkflow/js/views/Project';
import Register from '@/csmworkflow/js/views/Register';
import AuditLog from '@/csmworkflow/js/views/AuditLog';
import Calendar from '@/csmworkflow/js/views/Calendar';
import Dashboard from '@/csmworkflow/js/views/Dashboard';
import MyProjects from '@/csmworkflow/js/views/MyProjects';
import GlobalAlert from '@/csmworkflow/js/views/GlobalAlert';
import GlobalSearch from '@/csmworkflow/js/views/GlobalSearch';
import PasswordReset from '@/csmworkflow/js/views/PasswordReset';
import ForgotPassword from '@/csmworkflow/js/views/ForgotPassword';
import UserGlobalAlert from '@/csmworkflow/js/views/UserGlobalAlert';
import PermissionManager from '@/csmworkflow/js/views/PermissionManager';
import ProjectDeliverable from '@/csmworkflow/js/views/ProjectDeliverable';
import AddProjectDeliverable from '@/csmworkflow/js/views/AddProjectDeliverable';
import MediaCallPage from '@/csmworkflow/js/views/MediaCallPage';
import DashboardMediaCalls from '@/csmworkflow/js/views/DashboardMediaCalls';
import SocialMedia from '@/csmworkflow/js/views/SocialMedia';
import SocialMediaSchedule from '@/csmworkflow/js/views/SocialMediaSchedule';
import SocialMediaGrouped from '@/csmworkflow/js/views/SocialMediaGrouped';



Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/',
            component: Login
        },
        {
            path: '/forgot-password',
            name: 'forgotPassword',
            component: ForgotPassword
        },
        {
            path: '/password-reset/:token(.*)',
            name: 'passwordReset',
            component: PasswordReset
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            component: Dashboard,
            alias: '/deliverable/:deliverableId/:slug',
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/media-calls',
            name: 'mediaCallPage',
            component: MediaCallPage,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/calendar',
            name: 'calendar',
            component: Calendar,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/global-search',
            name: 'globalSearch',
            component: GlobalSearch,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/audit-log',
            name: 'auditLog',
            component: AuditLog,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/global-alert',
            name: 'globalAlert',
            component: GlobalAlert,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/user-global-alert',
            name: 'userGlobalAlert',
            component: UserGlobalAlert,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/report',
            name: 'report',
            component: Report,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
        },
        {
            path: '/my-week',
            name: 'myWeek',
            component: MyWeek,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/my-projects',
            name: 'myProjects',
            component: MyProjects,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/project',
            name: 'project',
            component: Project,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/project/:projectId/addDeliverable',
            name: 'addProjectDeliverable',
            component: AddProjectDeliverable,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/project/:projectId',
            name: 'projectDeliverable',
            component: ProjectDeliverable,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/permission-manager',
            name: 'permissionManager',
            component: PermissionManager,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/register',
            name: 'register',
            component: Register,
        },
        {
            path: '/logout',
            name: 'logout'
        },
        {
            path: '/dashboard/media-calls',
            name: 'dashboardMediaCalls',
            component: DashboardMediaCalls,
            meta: {
                requiresAuth: false
            }
        },
        {
            path: '/social-media',
            name: 'socialMedia',
            component: SocialMediaGrouped,
            props: true,
            alias: ['/social-media/:deliverableId/:slug', '/social-media/:deliverableId'],
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/social-media-grouped',
            name: 'socialMediaGrouped',
            component: SocialMediaGrouped,
            props: true,
            alias: ['/social-media-grouped/:deliverableId/:slug', '/social-media-grouped/:deliverableId'],
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/social-media-schedule',
            name: 'socialMediaSchedule',
            component: SocialMediaSchedule,
            props: true,
            alias: ['/social-media-schedule/:deliverableId/:slug', '/social-media-schedule/:deliverableId'],
            meta: {
                requiresAuth: true
            }
        },
    ]
});

router.beforeEach(async (to, from, next) => {

	// wait for components to trigger isDirty.
	  const waitForComponents = new Promise(resolve => {
	    const checkReady = setInterval(() => {
	      if (!store.getters.isDirty) {
	        clearInterval(checkReady);
	        resolve(true);
	      }
	    }, 250); // Check every 100ms
	  });
	  await waitForComponents;

	if (store.getters.isDirty) {
	  // Wait for `isReady` to become true
	  const loopCounter = 0;
	  const waitForReady = new Promise(resolve => {
	    const checkReady = setInterval(() => {
	      if (!store.getters.isDirty) {
	        clearInterval(checkReady);
	        resolve(true);
	      }
	      loopCounter++;
	      if (loopCounter > 100) {
	      	// navigate away after 10 seconds of waiting for the server.
	      	clearInterval(checkReady);
	      	resolve(true);
	      }
	    }, 100); // Check every 100ms
	  });
	  await waitForReady;
	}

    if ( to.name == "dashboardMediaCalls"){
        next()
    }else{
        if(store.getters.isLoggedIn) {
            store.dispatch('fetchUserPermissions');
            store.dispatch('fetchUserAlerts');
            store.dispatch('fetchAlerts');
            store.dispatch('fetchUserProjectsCount');
        }
        if (to.matched.some(record => record.meta.requiresAuth)) {
            // this route requires auth, check if logged in
            // if not, redirect to login page.
            if (!store.getters.authToken) {
                next({ name: 'login', query: { redirect: to.fullPath } })
            } else {
                next() // go to wherever I'm going
            }
        } else {
            if(store.getters.isLoggedIn) {
                next({name: 'myWeek'})
                //next()
            }
            next() // does not require auth, make sure to always call next()!
        }
    }

});

export default router;
